import React from "react";
import Logo from "../../assets/images/logo.png";
import Icon from "../Icon";
import { Link, useNavigate } from "react-router-dom";

export default function Header({ setSidebarOpen }) {
  const navigate = useNavigate();

  const goToSection = (section) => {
    const sectionElement = document.getElementById(section);
    if (sectionElement) {
      sectionElement.scrollIntoView({ behavior: "smooth" });
    } else {
      // If section doesn't exist on current page, navigate to partners page and then scroll
      navigate(`/partners`);
      setTimeout(() => {
        const targetElement = document.getElementById(section);
        if (targetElement) {
          targetElement.scrollIntoView({ behavior: "smooth" });
        }
      }, 100);
    }
  };

  return (
    <>
      <header className="md:hidden flex justify-between items-center !p-0 w-full">
        <button
          onClick={() => {
            setSidebarOpen(true);
          }}
          className="bg-[#F7F2FD1A] p-[6px] rounded-[8px]"
        >
          <Icon
            icon="heroicons:bars-3"
            className="w-[24px] h-[24px] text-neutral-100"
            alt="Menu"
          />
        </button>
        <Link to="/partners" className="flex items-center gap-2">
          <img src={Logo} className="-mt-1 w-auto h-[14px]" alt="logo" />
          <div className="font-semibold text-[16px] text-white uppercase tracking-wide">
            FOR PARTNERS
          </div>
        </Link>
        <div className="w-[40px]"></div>
      </header>
      <header className="max-md:hidden flex justify-between items-center mt-[16px] !p-0 w-full">
        <Link to="/partners" className="flex items-center gap-2">
          <img src={Logo} className="-mt-1 w-auto h-[18px]" alt="logo" />
          <div className="font-semibold text-[20px] text-white uppercase tracking-wide">
            FOR PARTNERS
          </div>
        </Link>
        <div className="flex items-center gap-[24px]">
          <button
            onClick={() => {
              goToSection("case-studies");
            }}
            className="text-[16px] text-white hover:text-neutral-200 transition-all"
          >
            Case studies
          </button>
          <button
            onClick={() => {
              goToSection("how-it-works");
            }}
            className="text-[16px] text-white hover:text-neutral-200 transition-all"
          >
            Hoe het werkt
          </button>
          <Link
            to="/login"
            className="font-normal text-[16px] text-white hover:text-neutral-200 transition-all"
          >
            Inloggen
          </Link>
        </div>
        <button
          onClick={() => {
            goToSection("signup");
          }}
          className="flex justify-center items-center px-[20px] border border-[#7721E5] rounded-[6px] h-[52px] font-semibold text-[16px] text-white premium-button"
        >
          Meld je aan
        </button>
      </header>
    </>
  );
}
